import { useState } from "react";

const EmbedCard = ({ report }) => {
  const [copied, setCopied] = useState(false);
  const appBaseUrl = window.location.origin;
  const embedTargetUrl = (report?.url || "").trim();
  const embedSrc = embedTargetUrl
    ? `${appBaseUrl}/embed/seo-score?url=${encodeURIComponent(embedTargetUrl)}`
    : "";
  const previewEmbedSrc = embedSrc ? `${embedSrc}&preview=true` : "";
  const embedSnippet = embedSrc
    ? `<iframe src="${embedSrc}" title="SEO Score Widget" width="420" height="132" style="border:0;overflow:hidden" loading="lazy"></iframe>\n<a href="${appBaseUrl}" target="_blank" rel="noopener noreferrer">Powered by Nova SEO</a>`
    : "";

  const copyEmbedSnippet = async () => {
    if (!embedSnippet) return;
    try {
      await navigator.clipboard.writeText(embedSnippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // Fallback
      alert("Could not copy snippet automatically. Please copy it manually.");
    }
  };

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <h3 className="page-subtitle" style={{ marginTop: 0 }}>Embed This Score Widget</h3>
      <p style={{ color: "var(--text-muted)", marginTop: 0, marginBottom: 16 }}>
        Display a live branded SEO score widget directly on your own site.
      </p>

      <div style={{ display: "flex", gap: 24, alignItems: "stretch", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 300px" }}>
          <textarea
            value={embedSnippet || "Run an audit or enter a URL to generate the embed snippet."}
            readOnly
            rows={5}
            style={{
              width: "100%",
              border: "1px solid var(--border)",
              borderRadius: 8,
              padding: 10,
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
              fontSize: 12,
              background: "#f8fafc",
              color: "var(--text)",
            }}
          />
          <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <button type="button" className="btn btn-primary" onClick={copyEmbedSnippet} disabled={!embedSnippet} aria-label="Copy embed snippet">
              {copied ? "Copied!" : "Copy Snippet"}
            </button>
          </div>
        </div>

        <div style={{ flex: "1 1 300px", background: "#f1f5f9", padding: 16, borderRadius: 12, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ fontSize: "0.8rem", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 12, fontWeight: 600 }}>
            Live Preview
          </div>
          {previewEmbedSrc ? (
            <iframe
              src={previewEmbedSrc}
              title="SEO Score Widget Preview"
              style={{ border: "none", overflow: "hidden", width: "100%", maxWidth: 420, height: 132, background: "transparent" }}
            />
          ) : (
            <div style={{ height: 132, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-muted)", fontSize: "0.9rem" }}>
              Run an audit to see preview
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmbedCard;